var map = {
	"./add_annoucment.svg": "2cc5",
	"./add_annoucment_hover.svg": "fd33",
	"./add_meeting.svg": "58a0",
	"./add_meeting_hover.svg": "0249",
	"./arrow.svg": "f814",
	"./callendar-gray.svg": "aa9e",
	"./callendar.svg": "0e87",
	"./news.svg": "a8ac",
	"./send_e-mail.svg": "1958",
	"./send_e-mail_hover.svg": "3774",
	"./send_sms.svg": "3136",
	"./send_sms_hover.svg": "2aac",
	"./time.svg": "53d7",
	"./warning.svg": "1545"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81ab";